import { AttributeInput } from "services/interface";
import styled from "@emotion/styled";
import { FormInstance, Row, UploadFile } from "antd";
import { FC } from "react";
import ProductAtributteCard from "../CreateProduct/ProductAttributeCard";
import ProductCategoryCard from "../CreateProduct/ProductCategoryCard";
import ProductDescriptionForm from "../CreateProduct/ProductDescriptionForm";
import ProductImageCard from "../CreateProduct/ProductImageCard";
//import ProductImageDesCard from "../CreateProduct/ProductImageDesCard";
import ProductNameForm from "../CreateProduct/ProductNameForm";
import ProductVariationCard from "../CreateProduct/ProductVariationCard";
import ProductRecommendForm from "../CreateProduct/ProductRecommendForm";
import ProductOpenSaleForm from "../CreateProduct/ProductOpenSale";
import ProductRetailTypeCard from "../CreateProduct/ProductRetailTypeCard";

interface MainUpdateProductProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  attribute: AttributeInput[];
  setAttribute: (attribute: AttributeInput[]) => void;
  setVariants: (variants: VariantsInput) => void;
  variants: VariantsInput;
  prices: PricesInput;
  setPrices: (prices: PricesInput) => void;
  images: UploadFile[] | undefined;
  checkIsActive: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
  setContent: (content: string) => void;
  content: string;
  is_guid: boolean;
  setIsGuid: (is_guid: boolean) => void;
  is_inventory: boolean;
  setIsInventory: (is_inventory: boolean) => void;
}

const MainUpdateProduct: FC<MainUpdateProductProps> = ({
  attribute,
  setAttribute,
  setVariants,
  variants,
  prices,
  setPrices,
  images,
  checkIsActive,
  setCheckIsActive,
  setContent,
  content,
  is_guid,
  setIsGuid,
  is_inventory,
  setIsInventory
}) => {
  return (
    <FormWrapper>
      {images && (
        <ProductImageCard
          is_active={checkIsActive}
          setCheckIsActive={setCheckIsActive}
          is_guid={is_guid}
          setIsGuid={setIsGuid}
        />
      )}
      <FormItemWrapper>
        {/* <ProductOpenSaleForm setCheckIsActive={setCheckIsActive} /> */}
        <ProductNameForm is_active={checkIsActive} />
        <ProductRecommendForm />
        <ProductDescriptionForm content={content} setContent={setContent}  is_active={checkIsActive} />
      </FormItemWrapper>
      {/* <ProductImageDesCard /> */}
      <FormItemWrapper>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          <ProductCategoryCard />
          <ProductRetailTypeCard is_active={checkIsActive} />
          <ProductVariationCard
            setVariants={setVariants}
            variants={variants}
            prices={prices}
            setPrices={setPrices}
            is_guid={is_guid}
            is_inventory={is_inventory}
          />
          <ProductAtributteCard
            attribute={attribute}
            setAttribute={setAttribute}
          />
        </Row>
      </FormItemWrapper>
    </FormWrapper>
  );
};

export default MainUpdateProduct;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
`;
